import React from "react";
import Tile from "~/Components/Tile";
import CommentForm from "~/Components/Forms/Comment/CommentForm";
import CommentList from "~/Components/CommentList";

const FeaturedOtdPost = ({ otd, archive = false }) => {
  if (!otd || !otd.id) return null;
  return (
    <Tile archive={archive} otd={otd}>
      <CommentForm postId={otd.id} post={otd}>
        <CommentList />
      </CommentForm>
    </Tile>
  );
};

export default FeaturedOtdPost;
